import { BooleanInput, TextInput, SelectInput } from "ra-ui-materialui";

const TopMenuForm = () => (
  <>
    <BooleanInput source="is_top_menu" />
    <TextInput
      source="title"
      multiline
      fullWidth
    />
    <TextInput
      source="title_en"
      multiline
      fullWidth
    />
    <TextInput
      source="route"
      fullWidth
    />
    <BooleanInput source="has_icon" />
    <SelectInput
      source="icon"
      choices={[
        { id: "Location", name: "Location" },
        { id: "Contacts", name: "Contacts" },
        { id: "Locale", name: "Locale" },
        { id: "Profile", name: "Profile" },
        { id: "Other", name: "Other" },
      ]}
    />
    <SelectInput
      source="seperator"
      choices={[
        { id: "FiberManualRecordIcon", name: "bullet" },
        { id: "VerticalSeparator", name: "vertical separator" },
      ]}
    />
    <BooleanInput source="has_hover" />
    <TextInput
      source="hover_text"
      multiline
      fullWidth
    />
    <TextInput
      source="hover_text_en"
      multiline
      fullWidth
    />
    <BooleanInput source="is_link" />
  </>
);

export default TopMenuForm;
